<div class="navbar bg-base-100 shadow-sm">
  <div class="flex items-center justify-between w-full max-w-[1200px] mx-auto gap-4">
    <a
      class="flex items-center gap-2.5 link link-accent min-w-0"
      routerLink="/"
      aria-label="На главную"
    >
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10">
        <lucide-icon name="brain" class="h-5 w-5 text-primary stroke-[2.5]" />
      </div>
      <span class="text-xl font-semibold tracking-tight truncate">Q-SPA</span>
    </a>

    @if (pageTitle(); as title) {
      <span class="text-base-content/80 text-sm truncate max-md:sr-only" aria-current="page">
        {{ title }}
      </span>
    }

    @if (isLandingContext() && breakpointService.deviceType() === 'desktop') {
      <nav
        class="flex items-center gap-6 flex-1 justify-center"
        aria-label="Разделы главной страницы"
      >
        <a class="link link-hover link-accent text-sm" routerLink="/" fragment="how"
          >Как это работает</a
        >
        <a class="link link-hover link-accent text-sm" routerLink="/" fragment="route"
          >Маршрут практик</a
        >
        <a class="link link-hover link-accent text-sm" routerLink="/" fragment="model"
          >О модели</a
        >
        <a class="link link-hover link-accent text-sm" routerLink="/" fragment="pro"
          >Полная версия и специалистам</a
        >
      </nav>
    }

    @if (authStore.isAuthenticated()) {
      @if (breakpointService.deviceType() !== 'desktop') {
        <div class="flex-none">
          <button
            type="button"
            class="btn btn-square btn-ghost min-h-11 min-w-11"
            aria-label="Открыть меню"
            (click)="toggleSidebar()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="inline-block h-5 w-5 stroke-current"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
      }
    } @else {
      <div class="flex items-center gap-2 flex-none">
        @if (breakpointService.deviceType() !== 'desktop' && isBlogContext()) {
          <button
            type="button"
            class="btn btn-square btn-ghost min-h-11 min-w-11"
            aria-label="Открыть меню блога"
            (click)="toggleSidebar()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="inline-block h-5 w-5 stroke-current"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        }
        <app-button [routerLink]="loginPath" text="Вход" variant="ghost" size="sm" />
        <app-button [routerLink]="registerPath" text="Регистрация" variant="primary" size="sm" />
      </div>
    }
  </div>
</div>
